// configs
import QuestionConfig from "../question/QuestionConfig";
import ActivityConfig from "../activity/ActivityConfig";
import ItemConfig from "../item/ItemConfig";
import ContentConfig from "./ContentConfig";

// players
import QuestionPlayer from "../question/QuestionPlayer";
import ActivityPlayer from "../activity/ActivityPlayer";
import ItemPlayer from "../item/ItemPlayer";
import BasePlayer from "../utils/BasePlayer";
import fetchContentProps from "../utils/fetchContentProps";

export default class ContentPlayer {
    public config: any;
    protected player: BasePlayer | undefined;

    constructor(protected contentProps: any = undefined) {
    }

    public async load(): Promise<{}> {
        await this.setConfig();
        await this.startLauncher();
        return {};
    }

    private startLauncher(): Promise<{}> {
        this.player = new BasePlayer(this.config);
        return this.player.startLauncher();
    }

    public async start(): Promise<{}> {
        await this.startPlayer();
        this.player = undefined;
        return Promise.resolve({});
    }

    protected async setConfig(): Promise<void> {
        this.contentProps = await fetchContentProps();
        console.log("ContentProps : ", this.contentProps);
        this.config = new ContentConfig(this.contentProps).targetConfig;
    }

    private startPlayer(): Promise<{}> | Error {
        if (this.config instanceof QuestionConfig) {
            return this.startQuestionPlayer(this.config);
        } else if (this.config instanceof ItemConfig) {
            return this.startItemPlayer(this.config);
        } else if (this.config instanceof ActivityConfig) {
            return this.startActivityPlayer(this.config);
        } else {
            return new Error(`Provided config cannot start any player. Config :${this.config}`);
        }
    }

    private startQuestionPlayer(config: QuestionConfig): Promise<{}> {
        this.player = new QuestionPlayer(config);
        return this.player.start();
    }

    private startActivityPlayer(config: ActivityConfig): Promise<{}> {
        this.player = new ActivityPlayer(config);
        return this.player.start();
    }

    private startItemPlayer(config: ItemConfig): Promise<{}> {
        this.player = new ItemPlayer(config);
        return this.player.start();
    }
}
